<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
};
</script>
<template>
  <div class="section_information container-fluid about-section green-bg mt-5">
    <div class="row" v-if="data.image.length > 0">
      <div class="col-lg-6 col-12 mb-5">
        <div class="row text-center">
          <div class="col-sm-12 section-text">
            <h3 class="text-white pt-5">
              <span class="span-hr-white-left"></span>Pengumuman
            </h3>
            <h2 class="text-white">{{ data.title }}</h2>
            <!-- <button class="btn btn-lg btn-pill btn-outline-light">Lihat Selengkapnya</button> -->
            <router-link
              to="/pengumuman"
              class="btn ht-btn-default--round mt-4 btn-primary-theme-white"
              >LIHAT INFO</router-link
            >
          </div>
        </div>
      </div>
      <img class="img-fluid image_information" :src="data.image" alt="image" />
    </div>
    <div class="row" v-else>
      <div class="col-lg-6 col-12 mb-5">
        <div class="row text-center">
          <div class="col-sm-12 section-text">
            <h3 class="text-white pt-5">
              <span class="span-hr-white-left"></span>Pengumuman
            </h3>
            <h2 class="text-white">Belum tersedia</h2>
            <!-- <button class="btn btn-lg btn-pill btn-outline-light">Lihat Selengkapnya</button> -->
            <router-link
              to="#"
              class="btn ht-btn-default--round mt-4 btn-primary-theme-white"
              >LIHAT INFO</router-link
            >
          </div>
        </div>
      </div>
      <img
        src="@/assets/images/global/list_empty.png"
        alt="image"
        style="float:left;width:50%;height:100%;"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-green/index.scss";
</style>
<style>
.section-text {
  margin-top: 80px;
  padding-left: 80px;
}
</style>
